import React from 'react';
import copy from 'copy-to-clipboard';
import cn from 'classnames';

import { share } from 'client/utils/share';
import { SHARE_CONSTANTS } from 'client/constants';
import { useGAEventCommonProps } from 'client/hooks/ga-event-common-props';
import { analytics } from 'client/utils/analytics';

import Icon from '../../Icon';

import css from './SharesMenu.module.scss';

interface Props {
  className?: string;
  closeMenu: () => void;
}

const SharesMenu: React.FC<Props> = (props) => {
  const { className = '', closeMenu } = props;
  const { common } = useGAEventCommonProps();

  const clickOnShare = (e: React.SyntheticEvent<HTMLDivElement>) => {
    const type = e.currentTarget.dataset.id;

    if (type === 'facebook' || type === 'whatsApp' || type === 'twitter') {
      share(type);

      analytics.gtag.event('audio_chat_user_interaction', {
        ...common,
        share: type,
      });
    }
  };

  const clickOnCopy = () => {
    copy(window.location.href);
    analytics.gtag.event('audio_chat_content_click', {
      ...common,
      text_clicked: 'Link copied',
    });
    closeMenu();
  };

  const clickOnOverlay = () => {
    closeMenu();
  };

  return (
    <div className={cn(css.sharesMenu, className)} data-testid="share-menu">
      <div className={css.overlay} data-testid="sm-overlay" onClick={clickOnOverlay}></div>
      <div className={css.menu}>
        <div className={css.btn} onClick={clickOnCopy}>
          <Icon type="link" />
        </div>
        <div className={css.btn} data-testid="sm-share-btn" data-id={SHARE_CONSTANTS.TWITTER} onClick={clickOnShare}>
          <Icon type="twitter" />
        </div>
        <div className={css.btn} data-id={SHARE_CONSTANTS.WHATSAPP} onClick={clickOnShare}>
          <Icon type="whatsapp" />
        </div>
        <div className={css.btn} data-id={SHARE_CONSTANTS.FACEBOOK} onClick={clickOnShare}>
          <Icon type="facebook" />
        </div>
      </div>
    </div>
  );
};

export default SharesMenu;
